module.exports = __webpack_public_path__ + "img/goal-09.abdfc0c9.png";